import vSignupPrice from "./v-signup-price.vue";

export default Vue => {
  Vue.component("v-signup-price", vSignupPrice);
};
